export const assign_reviewers = {
  Edit_steps: "Editar pasos",
  New_group_name: "Nuevo nombre de grupo",
  Previously_created_groups: "Grupos creados anteriormente",
  Save_this_group: "Guardar este grupo",
  Selected_Theme: "Tema seleccionado",
  Steps: "Pasos",
} as const;
